import { InjectedConnector } from "@web3-react/injected-connector";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { WalletLinkConnector } from "@web3-react/walletlink-connector";
// import { LedgerConnector } from "@web3-react/ledger-connector";
// import { TrezorConnector } from "@web3-react/trezor-connector";
// import { FrameConnector } from "@web3-react/frame-connector";
// import { FortmaticConnector } from "@web3-react/fortmatic-connector";

const POLLING_INTERVAL = 12000;
const RPC_URLS = {
  1: "https://mainnet.infura.io/v3/1eb884084d77488cb2e87bd298bc7cb8",
  4: "https://rinkeby.infura.io/v3/1eb884084d77488cb2e87bd298bc7cb8",
  56: "https://bsc-dataseed.binance.org",
  97: "https://bsc-dataseed.binance.org",
  137: "https://rpc-mainnet.matic.network",
  8453: "https://base-rpc.publicnode.com",
  84532: "https://base-sepolia.publicnode.com",
  396: "https://rpc.pulsechain.com",
  43114: "https://api.avax.network/ext/bc/C/rpc",
};

export const injected = new InjectedConnector({
  supportedChainIds: [
    1, 3, 4, 5, 42, 56, 97, 137, 250, 8453, 84532, 43114, 396,
  ],
});

export const injectedtw = new InjectedConnector({
  supportedChainIds: [
    1, 3, 4, 5, 42, 56, 97, 137, 250, 8453, 84532, 43114, 396,
  ],
});

export const walletconnect = (chainId) => {
  return new WalletConnectConnector({
    rpc: {
      [chainId]: RPC_URLS[chainId],
    },
    supportedChainIds: [1, 3, 4, 5, 56, 97, 137, 250, 8453, 84532, 43114, 396],
    bridge: "https://bridge.walletconnect.org",
    qrcode: true,
    pollingInterval: POLLING_INTERVAL,
  });
};

export const WalletLink = (chainId) => {
  return new WalletLinkConnector({
    url: RPC_URLS[chainId],
    appName: "Starter.xyz",
    appLogoUrl: "https://starter.xyz/logo_x200.png",
  });
};

// export const ledger = new LedgerConnector({
//   chainId: 1,
//   url: RPC_URLS[1],
//   pollingInterval: POLLING_INTERVAL,
// });

// export const trezor = new TrezorConnector({
//   chainId: 1,
//   url: RPC_URLS[1],
//   pollingInterval: POLLING_INTERVAL,
//   manifestEmail: "dummy@abc.xyz",
//   manifestAppUrl: "https://8rg3h.csb.app/",
// });

// export const frame = new FrameConnector({ supportedChainIds: [1] });

// export const fortmatic = new FortmaticConnector({
//   apiKey: "pk_live_F95FEECB1BE324B5",
//   chainId: 1,
// });
